import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let FormatNotificationCountMixin = class FormatNotificationCountMixin extends Vue {
    /**
     * Notification Count Formatter
     * Render 99+ when notification count exceeds or equal to 99
     * @author Peter John Alvarado <peterjohn@gorated.ph>
     * @since Version {0.5.0}
     *
     * @param {number} count notification count
     *
     * @return {number|string} formatted notification count
     */
    formatNotificationCount(count) {
        const max = 99;
        if (count >= max) {
            return `${max}+`;
        }
        return count;
    }
};
FormatNotificationCountMixin = __decorate([
    Component
], FormatNotificationCountMixin);
export default FormatNotificationCountMixin;
